import styled from 'styled-components';
export var MenuItem = styled.div.withConfig({
  displayName: "QueryArgumentsstyles__MenuItem",
  componentId: "keen-query-creator__sc-1l3kee0-0"
})(["&&&{flex:1;max-width:320px;min-width:285px;}"]);
export var MenuItemPercentile = styled.div.withConfig({
  displayName: "QueryArgumentsstyles__MenuItemPercentile",
  componentId: "keen-query-creator__sc-1l3kee0-1"
})(["&&&{flex-shrink:0;}"]);
export var Container = styled.div.withConfig({
  displayName: "QueryArgumentsstyles__Container",
  componentId: "keen-query-creator__sc-1l3kee0-2"
})(["&&&{display:flex;flex-wrap:wrap;grid-gap:20px;}"]);